import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Home = () => import('@/pages/home');
const MsgBoard = () => import('@/pages/msgBoard');
const Shopping = () => import('@/pages/shopping');
const Info = () => import('@/pages/info');
const Classify = () => import('@/pages/classify');
// const OrderForm= () => import('@/pages/orderForm')

export default new Router({
  routes: [{
    path: '/',
    component: Home,
  }, {
    path: '/msgBoard',
    component: MsgBoard,
  }, {
    path: '/shopping',
    component: Shopping,
  }, {
    path: '/info',
    component: Info,
  }, {
    path: '/classify',
    component: Classify,
  }]
})

//可跳转相同页面
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}



// WEBPACK FOOTER //
// ./src/router/index.js